@if (zoneData) {
  <div id="chart"></div>
} @else {
  <div class="no-data-center">{{'common.no_data_small' | translate}}</div>
}
